import { ArrowUpRight, Link2, Plus, Ticket as TicketIcon, X } from 'lucide-react';
import type { ContactConversation, Ticket } from '../../app/legacy-types';

type ContactTicketPanelProps = {
  conversation: ContactConversation;
  tickets: Ticket[];
  selectedTicketId: string;
  linking: boolean;
  onSelectionChange: (ticketId: string) => void;
  onLink: () => void;
  onUnlink: () => void;
  onOpen: () => void;
  onCreate: () => void;
};

export function ContactTicketPanel(props: ContactTicketPanelProps) {
  const ticket = props.tickets.find(item => item.id === props.conversation.linked_ticket_id);

  return <section className="surface contact-info-card contact-ticket-panel">
    <div className="surface-head compact contact-ticket-panel__head">
      <span className="contact-ticket-panel__icon"><TicketIcon /></span>
      <div><h2>Заявка</h2><p>{props.conversation.linked_ticket_id ? 'Обращение уже связано' : 'Продолжите работу в сервисной заявке'}</p></div>
    </div>
    {props.conversation.linked_ticket_id ? <div className="contact-ticket-linked">
      <button type="button" className="contact-ticket-linked__main" onClick={props.onOpen}>
        <span><small>{props.conversation.linked_ticket_display || 'Связанная заявка'}</small><b>{ticket?.subject || props.conversation.title}</b></span>
        <ArrowUpRight />
      </button>
      <button type="button" className="contact-ticket-unlink" onClick={props.onUnlink} disabled={props.linking}><X /> Отвязать</button>
    </div> : <div className="contact-ticket-empty">
      <div className="contact-ticket-create-copy"><span><Plus /></span><div><b>Создать из диалога</b><small>Клиент, переписка и вложения будут перенесены автоматически</small></div></div>
      <button type="button" className="button primary wide contact-ticket-create" onClick={props.onCreate}><Plus /> Создать заявку</button>
      <div className="contact-ticket-divider"><span>или связать существующую</span></div>
      <label className="contact-ticket-select"><span>Заявка</span><select value={props.selectedTicketId} onChange={event => props.onSelectionChange(event.target.value)}><option value="">Выберите заявку</option>{props.tickets.map(item => <option key={item.id} value={item.id}>{item.display_number} — {item.subject}</option>)}</select></label>
      <button type="button" className="button ghost wide" onClick={props.onLink} disabled={!props.selectedTicketId || props.linking}><Link2 /> {props.linking ? 'Связываем…' : 'Связать с диалогом'}</button>
    </div>}
  </section>;
}
